export const Channels = {
  groups: {
    allPatientsChannelGroup: () =>
      `chat_gp_patients`,
    userIdChannelGroup: (userId: number) => `chat_gp_user_${userId}`,
    instCareUserIdChannelGroup: (userId: number) =>
    `insta_care_gp_user_${userId}`,
  },
  
};

export const enum ChannelKeys {
  PatientChannel = 'PatientChannel',
  PatientCaregiverChannel = 'PatientCaregiverChannel',
  UserP2PChannel = 'UserP2PChannel',
  UserWatchlistChannel = 'UserWatchlistChannel',
}
